"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.compactString = void 0;
/**
 * Compacts human readable templates
 * ```js
 * compact`
 *   This is title
 *   My content goes here
 * `
 * // This is title\nMy content goes here
 * ```
 */
function compactString(tokens, ...values) {
    let str = '';
    for (let index = 0; index < tokens.length; index++) {
        str += tokens[index];
        const value = values[index];
        if (value === null || value === undefined || value === '' || value === false)
            continue;
        str += value.toString();
    }
    return str.replace(/^ +/gm, '').trim();
}
exports.compactString = compactString;
//# sourceMappingURL=compactString.js.map